var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0006 22C6.47769 22 2 17.5226 2 12C2.00626 6.47991 6.48019 2.00626 12.0006 2C17.5223 2 22 6.47741 22 12C22 17.5226 17.5223 22 12.0006 22ZM12.0006 3.66729C7.39776 3.66729 3.66614 7.39742 3.66614 12C3.67115 16.6001 7.40026 20.3277 12.0006 20.3327C16.6022 20.3327 20.3339 16.6026 20.3339 12C20.3339 7.39742 16.6022 3.66729 12.0006 3.66729ZM10.6019 13.9212L8.98578 12.3052C8.57895 11.8984 7.91925 11.8984 7.51367 12.3052C7.10683 12.712 7.10683 13.3717 7.51367 13.7773L11.2628 17.5274C11.4581 17.7227 11.7235 17.8328 12.0001 17.8328C12.2755 17.8328 12.5409 17.7227 12.7362 17.5274L16.4853 13.7773C16.8921 13.3717 16.8921 12.712 16.4853 12.3052C16.0797 11.8984 15.42 11.8984 15.0132 12.3052L13.3971 13.9212C13.337 13.98 13.2482 13.9976 13.1705 13.965C13.0929 13.9337 13.0416 13.8574 13.0416 13.7735V7.20822C13.0416 6.63368 12.5747 6.16679 12.0001 6.16679C11.4243 6.16679 10.9586 6.63368 10.9586 7.20822V13.7735C10.9586 13.8574 10.9073 13.9337 10.8297 13.9663C10.7521 13.9988 10.6619 13.9813 10.6019 13.9212Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/DownArrow.0c1ad3acb246c166e04812770b50e138.svg";
export { ForwardRef as ReactComponent };